import { makeStyles, styled } from "@material-ui/core";
import { asDate, colors, div, Flex, ReadOnly } from "lqx-react/lib";
import React from "react";

export const useSocCommonStyles = makeStyles({
    promiseToPayField: {
        maxWidth: 200
    },
    missingUndisputed: {
        color: colors.red
    }
});

const useStyles = makeStyles({
    h1: {
        fontFamily: 'Montserrat',
        fontSize: 20,
        fontWeight: 500,
        color: '#052C4C'
    },
    strike: {
        textDecoration: 'line-through'
    },
    popup: {
        minHeight: 300
    }
});

export const SocDialogInvoiceTile = ({ invoice }: { invoice: any }) => {
    let styles = useStyles();
    return (
        <SmallBox>
            <BoldField >{invoice.invoiceNumber}</BoldField>
            {
                invoice.promiseToPayDateUtc ? <>
                    <BoldField className={styles.strike}>{asDate(invoice.promiseToPayDateUtc)}</BoldField>
                    <BoldField style={{ color: colors.red }}>Update</BoldField>
                </>
                    : <>
                        <Flex grow />
                        <BoldField>New</BoldField>
                    </>
            }
        </SmallBox>
    );
}

export const SocCompactInvoices = ({ title, invoices }: { title?: String, invoices: any[] }) => {
    return (
        <>
            <br />
            <p>{title}</p>
            <ReadOnly.Provider value={true}>
                <InvoicesContainer>
                    {
                        invoices.map(x => (
                            <SocDialogInvoiceTile key={x.cid}
                                invoice={x}
                            />
                        ))
                    }
                </InvoicesContainer>
            </ReadOnly.Provider>
        </>
    );
}

export const InvoicesContainer = div({
    display: "flex",
    flexDirection: "column",
    maxHeight: 200,
    overflowY: "auto"
})

export const BoldField = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    paddingLeft: 8,
    paddingRight: 8,
    minWidth: '14em',
    fontSize: 12,
    fontWeight: 600
});

export const SmallBox = div({
    padding: 8,
    boxShadow: '1px 0 2px 0 rgb(0 0 0 / 4%)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#f9f9f9',
    alignItems: 'center',
    margin: 4
})
